import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterSidebar = ({ filters, onFiltersChange, isOpen, onToggle }) => {
  const [expandedSections, setExpandedSections] = useState({
    themes: true
  });

  const filterSections = [
    {
      id: 'themes',
      title: 'Categorías',
      icon: 'Tag',
      options: [
        { id: 'agenda', label: 'Agenda', count: 0 },
        { id: 'autoayuda', label: 'Autoayuda', count: 0 },
        { id: 'curacion-emocional', label: 'Curación emocional', count: 0 },
        { id: 'relaciones', label: 'Relaciones', count: 0 },
        { id: 'infantil', label: 'Infantil', count: 0 },
        { id: 'amor', label: 'Amor', count: 0 },
      ]
    }
  ];

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev?.[sectionId]
    }));
  };

  const handleFilterChange = (sectionId, optionId, checked) => {
    const newFilters = { ...filters };
    if (!newFilters?.[sectionId]) {
      newFilters[sectionId] = [];
    }

    if (checked) {
      newFilters[sectionId] = [...newFilters?.[sectionId], optionId];
    } else {
      newFilters[sectionId] = newFilters?.[sectionId]?.filter(id => id !== optionId);
    }

    onFiltersChange(newFilters);
  };

  const clearAllFilters = () => {
    onFiltersChange({});
  };

  const getActiveFiltersCount = () => {
    return Object.values(filters)?.reduce((total, filterArray) => {
      return total + (Array.isArray(filterArray) ? filterArray?.length : 0);
    }, 0);
  };

  return (
      <>
        {/* Mobile Overlay */}
        {isOpen && (
            <div
                className="lg:hidden fixed inset-0 bg-black/40 z-40"
                onClick={onToggle}
            />
        )}

        {/* Sidebar */}
        <aside
            className={`fixed lg:sticky top-20 left-0 h-[calc(100vh-5rem)] lg:h-auto
        w-80 lg:w-full z-50 lg:z-auto
        literary-transition-complex overflow-y-auto
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
        >
          <div className="bg-white text-primary rounded-lg p-6 mb-6 shadow-lg">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center">
                  <Icon name="Filter" size={16} className="text-white" />
                </div>
                <div>
                  <h2 className="font-headline text-lg font-semibold">
                    Filtros
                  </h2>
                  {getActiveFiltersCount() > 0 && (
                      <p className="font-body text-sm text-white/80">
                        {getActiveFiltersCount()} filtros activos
                      </p>
                  )}
                </div>
              </div>

              <button
                  onClick={onToggle}
                  className="lg:hidden p-2 rounded-md literary-transition text-white/80 hover:text-white hover:bg-white/10"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            {/* Clear Filters */}
            {getActiveFiltersCount() > 0 && (
                <div className="mb-6">
                  <Button
                      variant="outline"
                      size="sm"
                      fullWidth
                      onClick={clearAllFilters}
                      className="font-cta bg-white text-primary hover:bg-white/90"
                  >
                    <Icon name="RotateCcw" size={16} className="mr-2" />
                    Limpiar Filtros
                  </Button>
                </div>
            )}

            {/* Filter Sections */}
            <div className="space-y-6">
              {filterSections?.map((section) => (
                  <div key={section?.id} className="border-b border-white/20 pb-6 last:border-b-0">
                    <button
                        onClick={() => toggleSection(section?.id)}
                        className="flex items-center justify-between w-full mb-4 literary-transition hover:text-white"
                    >
                      <div className="flex items-center space-x-2">
                        <Icon name={section?.icon} size={16} className="text-primary" />
                        <h3 className="font-headline text-sm font-semibold">
                          {section?.title}
                        </h3>
                      </div>
                      <Icon
                          name={expandedSections?.[section?.id] ? 'ChevronUp' : 'ChevronDown'}
                          size={16}
                          className="text-white/80"
                      />
                    </button>

                    {expandedSections?.[section?.id] && (
                        <div className="space-y-3">
                          {section?.options?.map((option) => (
                              <div key={option?.id} className="flex items-center justify-between">
                                <Checkbox
                                    label={option?.label}
                                    checked={filters?.[section?.id]?.includes(option?.id) || false}
                                    onChange={(e) => handleFilterChange(section?.id, option?.id, e?.target?.checked)}
                                    className="flex-1 text-white"
                                />
                              </div>
                          ))}
                        </div>
                    )}
                  </div>
              ))}
            </div>
          </div>
        </aside>
      </>
  );
};

export default FilterSidebar;
